import React, { useContext } from 'react';

/* packages */
import Fetch from '../../../util-fetch';
/* packages */

/* stores */
import ListStore from './store';
/* stores */

const Index = ({CONFIG, token}) => {
  const productCat2ListContext  = useContext(ListStore);
  const productCat2ListMethod = async () => {
    productCat2ListContext.setLoading(true);
    CONFIG.application.product.api.headers.Authorization = token;
    const fetch = await Fetch({
      url: CONFIG.application.product.api.endpoints.list_Cat2.url,
      config: {
        method: CONFIG.application.product.api.endpoints.list_Cat2.method,
        headers: CONFIG.application.product.api.headers
      }
    });
    productCat2ListContext.setStatus(fetch[0]);
    productCat2ListContext.setData(fetch[1]);
    productCat2ListContext.setLoading(false);
  }
  const productCat2ListData = productCat2ListContext.isData();

  return { productCat2ListContext, productCat2ListMethod, productCat2ListData }
}

export default Index;
